import {carouselSettingState} from '../state/carouselSettingState';
import {Fetch_All_CarouselSettings_Data, Update_Carousel_List_Success,
            Carousel_Data_Success,Fetch_Carousel_Setting_Request} from '../action/carouselSettingAction';

export function CarouselSettingReducer(state = carouselSettingState, action) {
    switch(action.type){
        case Fetch_All_CarouselSettings_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                carouselList : action.carouselList
            })
        case Update_Carousel_List_Success:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                carouselList : action.UpdatedList,
                message : action.message
            })
        case Carousel_Data_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.Message,
                UpdatedList : action.list
            })
        case Fetch_Carousel_Setting_Request:
            return Object.assign({},state,{
                message : '',
                statusCode : 0
            })
        default:
            return state
    }
}